// lenis smooth scroll
// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  // Ignore elements with the class 'scroll-section' (or any other class you use)
  ignore: (el) => el.classList.contains("scroll-section"),
});

// Update ScrollTrigger on Lenis scroll
lenis.on("scroll", ScrollTrigger.update);

// Integrate Lenis's request animation frame with GSAP's ticker
gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

// Disable GSAP's lag smoothing to match Lenis
gsap.ticker.lagSmoothing(0);

// -------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  const heroSection = document.querySelector(".natty_hero");
  const headerMenuLinks = document.querySelectorAll(
    ".natty-header-menu ul li a, .natty-navigation-menu ul li span, .natty-navigation-menu ul li a"
  );
  const header = document.querySelector(".natty-header");
  const headerLogoSVG = document.querySelectorAll(
    ".natty-header-logo-svg path"
  );
  const headerMenuItems = document.querySelectorAll(".natty-header-menu ul li");
  const navigationMenuItems = document.querySelectorAll(
    ".natty-navigation-menu ul li"
  );

  let observer = null; // Store observer reference

  function setupObserver() {
    if (window.innerWidth > 950) {
      // Only create observer if it's not already active
      if (!observer) {
        observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                // When in viewport
                header.style.background = "transparent";
                header.style.borderBottom = "1px solid #fff";
                headerMenuLinks.forEach((link) => {
                  link.style.color = "#fff";
                });
                headerLogoSVG.forEach((path) => {
                  path.style.fill = "#fff";
                });
                headerMenuItems.forEach((li) => {
                  li.style.borderRight = "1px solid #fff";
                });
                navigationMenuItems.forEach((li) => {
                  li.style.borderLeft = "1px solid #fff";
                });
              } else {
                // When out of viewport
                resetStyles();
              }
            });
          },
          { threshold: 0.1 }
        );

        observer.observe(heroSection);
      }
    } else {
      // If screen size is 950px or below, stop the observer and reset styles
      if (observer) {
        observer.disconnect();
        observer = null;
        resetStyles();
      }
    }
  }

  function resetStyles() {
    header.style.background = "";
    header.style.borderBottom = "";
    headerMenuLinks.forEach((link) => {
      link.style.color = "";
    });
    headerLogoSVG.forEach((path) => {
      path.style.fill = "";
    });
    headerMenuItems.forEach((li) => {
      li.style.borderRight = "";
    });
    navigationMenuItems.forEach((li) => {
      li.style.borderLeft = "";
    });
  }

  // Run the function on page load and on window resize
  setupObserver();
  window.addEventListener("resize", setupObserver);
});

// to make video parallax

document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(
    ".natty-transparent-section, .natty-transparent-section2"
  );

  // Function to check device type
  const isMobile = () => window.innerWidth <= 950; // Adjust breakpoint for mobile if needed

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const desktopVideo = entry.target.querySelector(".t-desktop");
        const mobileVideo = entry.target.querySelector(".t-mobile");

        if (entry.isIntersecting) {
          if (isMobile()) {
            if (mobileVideo) {
              mobileVideo.style.display = "block";
              setTimeout(() => {
                mobileVideo.style.opacity = "1";
                mobileVideo.style.filter = "grayscale(0)";
              }, 10);
            }
            if (desktopVideo) {
              desktopVideo.style.display = "none";
              desktopVideo.style.opacity = "0";
              desktopVideo.style.filter = "grayscale(1)";
            }
          } else {
            if (desktopVideo) {
              desktopVideo.style.display = "block";
              setTimeout(() => {
                desktopVideo.style.opacity = "1";
                desktopVideo.style.filter = "grayscale(0)";
              }, 10);
            }
            if (mobileVideo) {
              mobileVideo.style.display = "none";
              mobileVideo.style.opacity = "0";
              mobileVideo.style.filter = "grayscale(1)";
            }
          }
        } else {
          if (desktopVideo) {
            desktopVideo.style.opacity = "0";
            desktopVideo.style.filter = "grayscale(1)";
            setTimeout(() => {
              desktopVideo.style.display = "none";
            }, 200);
          }
          if (mobileVideo) {
            mobileVideo.style.opacity = "0";
            mobileVideo.style.filter = "grayscale(1)";
            setTimeout(() => {
              mobileVideo.style.display = "none";
            }, 200);
          }
        }
      });
    },
    { threshold: 0 }
  );

  sections.forEach((section) => observer.observe(section));

  // Listen for window resize to handle changes in screen size dynamically
  window.addEventListener("resize", () => {
    sections.forEach((section) => {
      const desktopVideo = section.querySelector(".t-desktop");
      const mobileVideo = section.querySelector(".t-mobile");

      if (desktopVideo && mobileVideo) {
        if (isMobile()) {
          mobileVideo.style.display = "block";
          desktopVideo.style.display = "none";
        } else {
          desktopVideo.style.display = "block";
          mobileVideo.style.display = "none";
        }
      }
    });
  });
});
// =====================================================
document.addEventListener("click", function (event) {
  // Check if the clicked element has the class .quick-add-btn
  const clickedElement = event.target;
  // console.log(clickedElement);
  // ============== If Clicked on Quick Add Btn Then call Function ===============
  if (clickedElement.classList.contains("quick-add-btn")) {
    quickAddCartDrawer(clickedElement);
  }
});

// ========================= Quick Add Cart Drawer Function========================================
function quickAddCartDrawer(clickedElemrnt) {
  const productId = event.target.getAttribute("data-product-id");
  const variantId = event.target.getAttribute("data-variant-id");
  const cartDrawer = document.querySelector(".drawer__cart-items-wrapper");
  // Make sure the product ID and variant ID exist
  if (!productId || !variantId) {
    console.error("Product ID or Variant ID is missing.");
    return;
  }

  // Add the product to the cart via Shopify AJAX API
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id: variantId, // Use the variant ID from the clicked button
      quantity: 1, // Adding 1 quantity
    }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to add item to cart");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Added to cart:", data);
      // Optionally, update UI (like cart count, etc.)
      updateCartUI();
    })
    .catch((error) => {
      console.error("Error adding product to cart:", error);
    });
  // Function to update the cart UI (like cart count)
  function updateCartUI() {
    fetch("/cart")
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");
        const updatedCartDrawer = doc.querySelector(
          ".drawer__cart-items-wrapper"
        );

        if (cartDrawer && updatedCartDrawer) {
          fetch("/cart.js")
            .then((response) => response.json())
            .then((data) => {
              document.querySelector(
                ".cart-count-bubble"
              ).textContent = ` SHOPPING BAG (${data.item_count})`;
            });
          cartDrawer.innerHTML = updatedCartDrawer.innerHTML;
        }
      })
      .catch((error) => {
        console.error("Error updating cart UI:", error);
      });
  }
}
// ========================= Quick Add Cart Drawer Function [END]========================================

// to make video parallax

// timer by nilesh

// const countdownDate = new Date("Nov 22, 2024 21:00:00").getTime();

//     function updateCountdown() {
//       const now = new Date().getTime();
//       const distance = countdownDate - now;

//       const days = Math.floor(distance / (1000 * 60 * 60 * 24));
//       const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
//       const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
//       const seconds = Math.floor((distance % (1000 * 60)) / 1000);

//       document.getElementById("countdown").innerHTML =
//         `${days}D ${hours}H ${minutes}M ${seconds}S`;

//       if (distance < 0) {
//         clearInterval(countdownInterval);
//         document.getElementById("countdown").innerHTML = "Countdown Ended!";
//       }
//     }

//     const countdownInterval = setInterval(updateCountdown, 1000);

// (function () {
//   const second = 1000,
//         minute = second * 60,
//         hour = minute * 60,
//         day = hour * 24;

//   // Set the target date and time
//   let birthday = "11/22/2024 23:59:00";

//   const countDown = new Date(birthday).getTime(),
//       x = setInterval(function() {

//         const now = new Date().getTime(),
//               distance = countDown - now;

//         document.getElementById("days").innerText = Math.floor(distance / (day)),
//           document.getElementById("hours").innerText = Math.floor((distance % (day)) / (hour)),
//           document.getElementById("minutes").innerText = Math.floor((distance % (hour)) / (minute)),
//           document.getElementById("seconds").innerText = Math.floor((distance % (minute)) / second);

//         // Do something later when the date is reached
//         if (distance < 0) {
//           document.getElementById("headline").innerText = "DROP IS LIVE!";
//           document.getElementById("countdown").style.display = "none";
//           document.getElementById("content").style.display = "block";
//           clearInterval(x);
//         }
//         //seconds
//       }, 0)
// })();

// (function () {
//   const second = 1000,
//         minute = second * 60,
//         hour = minute * 60,
//         day = hour * 24;

//   // Set the target date and time
//   let birthday = "02/11/2025 20:59:59";

//   const countDown = new Date(birthday).getTime(),
//       x = setInterval(function() {

//         const now = new Date().getTime(),
//               distance = countDown - now;

//         // Helper function to format numbers with leading zeros
//         const formatNumber = (num) => (num < 10 ? `0${num}` : num);

//         document.getElementById("days").innerText = `${formatNumber(Math.floor(distance / day))}`;
//         document.getElementById("hours").innerText = `${formatNumber(Math.floor((distance % day) / hour))}`;
//         document.getElementById("minutes").innerText = `${formatNumber(Math.floor((distance % hour) / minute))}`;
//         document.getElementById("seconds").innerText = `${formatNumber(Math.floor((distance % minute) / second))}`;

//         // Do something later when the date is reached
//         if (distance < 0) {
//           document.getElementById("headline").innerText = "DROP IS LIVE!";
//           document.getElementById("countdown").style.display = "none";
//           document.getElementById("content").style.display = "block";
//           clearInterval(x);
//         }
//       }, 1000); // Adjusted interval to 1000ms (1 second)
// })();

// ---------------------------- dev3-------------------------------

(function () {
  const second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;

  // Set the target date and time
  // let birthday = "01/04/2025 20:59:59";
  const birthday = new Date("05/09/2025 23:59:59").getTime();

  const countDown = new Date(birthday).getTime(),
    x = setInterval(function () {
      const now = new Date().getTime(),
        distance = countDown - now;

      // Helper function to format numbers with leading zeros
      const formatNumber = (num) => (num < 10 ? `0${num}` : num);

      document.getElementById("days").innerText = `${formatNumber(
        Math.floor(distance / day)
      )}`;
      document.getElementById("hours").innerText = `${formatNumber(
        Math.floor((distance % day) / hour)
      )}`;
      document.getElementById("minutes").innerText = `${formatNumber(
        Math.floor((distance % hour) / minute)
      )}`;
      document.getElementById("seconds").innerText = `${formatNumber(
        Math.floor((distance % minute) / second)
      )}`;

      // Do something later when the date is reached
      if (distance < 0) {
        document.getElementById("headline").innerText = "DROP IS LIVE!";
        document.getElementById("countdown").style.display = "none";
        document.getElementById("content").style.display = "block";
        clearInterval(x);
      }
    }, 1000); // Adjusted interval to 1000ms (1 second)
})();

// ---------------------------- dev3-------------------------------

// timer end here by nilesh

//
document.addEventListener("DOMContentLoaded", function () {
  // Select headers
  var header2 = document.querySelector(".natty-header");
  var header3 = document.querySelector(".natty-header-container");
  var header5 = document.querySelector(".p-navbar");
  var header6 = document.querySelector(".m-product-container");
  var newHeader = document.querySelector(".collection-navbar");

  // Calculate header heights
  var headerHeight1 =
    (header2 ? header2.offsetHeight : 0) ||
    (header3 ? header3.offsetHeight : 0);
  var headerHeight2 =
    (header5 ? header5.offsetHeight : 0) ||
    (header6 ? header6.offsetHeight : 0);
  var headerHeight3 = newHeader ? newHeader.offsetHeight : 0;

  // Store initial scroll positions
  var lastScroll1 =
    document.documentElement.scrollTop || document.body.scrollTop;
  var lastScroll2 = lastScroll1;
  var lastScroll3 = lastScroll1;

  window.addEventListener("scroll", function () {
    var currentScroll =
      document.documentElement.scrollTop || document.body.scrollTop;

    // Handle .natty-header and .natty-header-container behavior if elements exist
    if (header2 && header3) {
      toggleHeaderClasses(
        header2,
        header3,
        currentScroll,
        headerHeight1,
        lastScroll1
      );
      lastScroll1 = currentScroll;
    }

    // Handle .p-navbar and .m-product-container behavior if elements exist
    if (header5 && header6) {
      toggleHeaderClasses(
        header5,
        header6,
        currentScroll,
        headerHeight2,
        lastScroll2
      );
      lastScroll2 = currentScroll;
    }

    // Handle .collection-navbar behavior if element exists
    if (newHeader) {
      toggleSingleHeaderClasses(
        newHeader,
        currentScroll,
        headerHeight3,
        lastScroll3
      );
      lastScroll3 = currentScroll;
    }
  });

  // Function to toggle classes for paired headers
  function toggleHeaderClasses(
    headerA,
    headerB,
    currentScroll,
    headerHeight,
    lastScroll
  ) {
    if (currentScroll > headerHeight) {
      headerA.classList.add("off-canvas");
      headerB.classList.add("off-canvas");
    } else {
      headerA.classList.remove("off-canvas");
      headerB.classList.remove("off-canvas");
    }

    if (currentScroll > lastScroll) {
      headerA.classList.remove("fixed");
      headerB.classList.remove("fixed");
    } else {
      headerA.classList.add("fixed");
      headerB.classList.add("fixed");
    }
  }

  // Function to toggle classes for a single header
  function toggleSingleHeaderClasses(
    header,
    currentScroll,
    headerHeight,
    lastScroll
  ) {
    if (currentScroll > headerHeight) {
      header.classList.add("off-canvas");
    } else {
      header.classList.remove("off-canvas");
    }

    if (currentScroll > lastScroll) {
      header.classList.remove("fixed");
    } else {
      header.classList.add("fixed");
    }
  }
});

// size chart start

function openSizeBox() {
  const sizeBoxArr = document.querySelectorAll(".size-box");
  sizeBoxArr[sizeBoxArr.length - 1].classList.toggle("size-box-active");
  // Add event listener for scroll
  document.addEventListener("scroll", closeSizeBoxOnScroll);
}

function closeSizeBoxOnScroll() {
  const sizeboxMenu = document.querySelector(".size-box");
  const relatedProducts = document.querySelector(".related-products");

  const sizeboxPosition = sizeboxMenu.getBoundingClientRect();
  const relatedProductsPosition = relatedProducts.getBoundingClientRect();

  if (sizeboxPosition.bottom >= relatedProductsPosition.top) {
    sizeboxMenu.classList.remove("size-box-active");
    document.removeEventListener("scroll", closeSizeBoxOnScroll);
  }
}

// footer accordion
document.querySelectorAll(".f-navlist p").forEach(function (pTag) {
  pTag.addEventListener("click", function () {
    const parentUl = pTag.parentElement; // Assuming 'col2' is the parent
    const contentWrapper = parentUl.querySelector("ul"); // Get the corresponding ul

    // Check if already active
    const isActive = parentUl.classList.contains("open");

    // Collapse all sections
    document.querySelectorAll(".f-navlist").forEach(function (item) {
      item.classList.remove("open");
      const ul = item.querySelector("ul");
      if (ul) {
        ul.style.maxHeight = "0"; // Collapse
      }
    });

    // Expand the clicked section if it's not active
    if (!isActive) {
      parentUl.classList.add("open");
      if (contentWrapper) {
        contentWrapper.style.maxHeight = contentWrapper.scrollHeight + "px"; // Set maxHeight to the scrollHeight
      }
    }
  });
});

// burger-menu drawer toggle start

document.addEventListener("DOMContentLoaded", function () {
  var icon2 = document.querySelector("#icon3");
  var mobileMenu = document.querySelector(".mobile-menu");

  icon2.onclick = function () {
    mobileMenu.classList.toggle("open");
    this.classList.toggle("open");

    // Change the text content between 'Menu' and 'Close'
    if (this.classList.contains("open")) {
      this.textContent = "[ Close ]";
      // Add class to body to disable scroll
      document.body.classList.add("no-scroll");
    } else {
      this.textContent = "Menu";
      // Remove class from body to enable scroll
      document.body.classList.remove("no-scroll");
    }
  };
});

// mobile menu toggles start

function toggleTshirtData() {
  const tshirtData = document.querySelector(".tshirst-data");
  tshirtData.classList.toggle("show");
}
// ----
function toggloverData() {
  const overData = document.querySelector(".oversize-datam");
  overData.classList.toggle("show");
}
// ----
function toggregularData() {
  const regularData = document.querySelector(".regular-datam");
  regularData.classList.toggle("show");
}
// -------
function toggleCapm() {
  const cpData = document.querySelector(".cap-datam");
  cpData.classList.toggle("show");
}

//

// ------------------------- product page size selection issue solve ---------

document.addEventListener("DOMContentLoaded", function () {
  // Select all elements whose ID contains '18559117721842'
  var refreshButtons = document.querySelectorAll(".refreshme");

  refreshButtons.forEach(function (button) {
    button.addEventListener("click", function (event) {
      // Check if the clicked element has the 'size_chart_button' class
      if (event.target.classList.contains("size_chart_button")) {
        return; // Do nothing and exit if the class is present
      }

      // Add a delay of 2 seconds (2000 milliseconds) before refreshing the page
      setTimeout(function () {
        // Reload the current page (using the current URL)
        location.href = location.href; // This ensures the current URL is reloaded
      }, 1000); // Delay time in milliseconds (2000ms = 2 seconds)
    });
  });
});

// ------------------------- product page size selection issue solve ---------

// ------------------------------- scroll using mouse in (natty_collection_slider) --------------------

// Get the slider element
const slider = document.querySelector(".natty_collection_slider");

// Variables to store mouse position
let isDragging = false;
let startX;
let scrollLeft;

slider.addEventListener("mousedown", (e) => {
  // When mouse button is pressed down, start dragging
  isDragging = true;
  startX = e.pageX - slider.offsetLeft; // Store the initial mouse position
  scrollLeft = slider.scrollLeft; // Store the initial scroll position
  slider.style.cursor = "grabbing"; // Change cursor to grabbing
});

slider.addEventListener("mouseleave", () => {
  // Stop dragging if mouse leaves the slider area
  isDragging = false;
  slider.style.cursor = "grab"; // Reset cursor when dragging stops
});

slider.addEventListener("mouseup", () => {
  // Stop dragging when mouse button is released
  isDragging = false;
  slider.style.cursor = "grab"; // Reset cursor
});

slider.addEventListener("mousemove", (e) => {
  // If the user is dragging
  if (!isDragging) return;

  e.preventDefault(); // Prevent text selection or other default behaviors
  const x = e.pageX - slider.offsetLeft; // Get the current mouse position
  const walk = (x - startX) * 1.5; // Scroll speed multiplier (adjust as needed)

  // Smooth scroll with `requestAnimationFrame` for fluid animation
  smoothScroll(walk);
});

// Function to handle smooth scrolling
function smoothScroll(walk) {
  // Update the scroll position in a smooth way
  const targetScroll = scrollLeft - walk;
  let currentScroll = slider.scrollLeft;

  // Use requestAnimationFrame for smooth scrolling
  function scrollAnimation() {
    const distance = targetScroll - currentScroll;
    if (Math.abs(distance) > 0.5) {
      // If still moving enough to continue
      currentScroll += distance * 0.1; // Gradual movement
      slider.scrollLeft = currentScroll;
      requestAnimationFrame(scrollAnimation);
    } else {
      slider.scrollLeft = targetScroll; // Set final scroll position
    }
  }

  requestAnimationFrame(scrollAnimation); // Start the animation loop
}

// ------------------------------- scroll using mouse in (natty_collection_slider) --------------------

document.addEventListener("DOMContentLoaded", function () {
  const bfsHeroDiv = document.querySelector(".BFS-hero-div");
  const colorScheme1 = document.querySelector(".color-scheme-1");

  // Register GSAP ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);

  // Create the ScrollTrigger to monitor the .color-scheme-1 position
  gsap.to(bfsHeroDiv, {
    scrollTrigger: {
      trigger: colorScheme1, // Set the target element to track
      start: "bottom 90%", // When the bottom of .color-scheme-1 reaches 10% from the bottom of the viewport
      end: "top 100%", // When the top of .color-scheme-1 reaches the top of the viewport
      scrub: true, // Ensures smooth animation along the scroll
      onEnter: () => {
        // Apply grayscale when entering the range
        gsap.to(bfsHeroDiv, {
          filter: "grayscale(1)",
          duration: 0.5,
        });
      },
      onLeaveBack: () => {
        // Remove grayscale when leaving the range
        gsap.to(bfsHeroDiv, {
          filter: "grayscale(0)",
          duration: 0.5,
        });
      },
    },
  });
});
